module.exports = __webpack_public_path__ + "static/logo-322d2b7dbcf513ebc4fdea651c4201fa.png";